export default __webpack_public_path__ + "static/shipping-3-af7d1d52a40ce311d20a906cc806ed9f.jpg";